import Glide from '@glidejs/glide';

export default function(dom, opts) {
	let options = {
		type: 'carousel',
		perView: 3,
		gap: 0,
		keyboard: false,
		breakpoints: {
			1023: {
				perView: 2,
			},
			767: {
				perView: 1,
			}
		},
		swipeThreshold: 80,
		dragThreshold: 120,
		perTouch: 0,
		touchRatio: 0.5,
		touchAngle: 45,
		rewind: true,
		...opts
	};
	const slideCount = [].slice.call(dom.querySelectorAll('.glide__slide'), 0).length;

	if (slideCount) {
		const glide = new Glide(dom.querySelector('.glide'), options).mount();
	}
}